import { useCallback, useState } from 'react';
import { TCardType, ECardTypes } from 'shared/types/card.interface';
import { TDebateStatus, EDebateStatuses } from 'shared/types/debates.interface';
import { TChallengeStatus } from 'shared/types/challenges.interface';

export const useMainButtonHover = (
  cardType: TCardType,
  status: TDebateStatus | TChallengeStatus,
) => {
  const [isPromptVisible, setPromptVisible] = useState(false);

  const checkOnHover = useCallback((): void => {
    if (cardType === ECardTypes.Debate && status === EDebateStatuses.Scheduled) {
      setPromptVisible(!isPromptVisible);
    }
  }, [cardType, isPromptVisible, status]);

  return { isPromptVisible, checkOnHover };
};
